import { create } from "zustand"

import { ListMode } from "@/types/common"

interface ListModeState {
  listMode: ListMode
  setListMode: (mode: ListMode) => void
}

export const useListModeStore = create<ListModeState>((set) => ({
  listMode: ListMode.CARDS,
  setListMode: (mode) => set({ listMode: mode }),
}))
